import Api from '../../../services';

export const getWishlist = () => {
  return (dispatch) => {
    return Api.guestApi.wishlist.getWishlist().then((response) => {
      dispatch({
        type: 'GET_WISHLIST',
        data: response,
      });
      return response;
    });
  };
};

export const addToWishlist = (listingId) => {
  return (dispatch) => {
    return Api.guestApi.wishlist.addToWishlist(listingId).then((response) => {
      dispatch({ type: 'ADD_TO_WISHLIST' });
      dispatch(getWishlist());
      return response;
    });
  };
};
export const removeFromWishlist = (listingId) => {
  return (dispatch) => {
    return Api.guestApi.wishlist.removeFromWishlist(listingId).then((response) => {
      dispatch({ type: 'REMOVE_FROM_WISHLIST' });
      dispatch(getWishlist());
      return response;
    });
  };
};
